var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    id: "logout_svg__\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".logout_svg__st0{clip-path:url(#logout_svg__SVGID_00000091713214487162258700000014894957219139264664_)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logout_svg__SVGID_1_",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "logout_svg__SVGID_00000085218296141554948930000003584226611213374366_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logout_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#logout_svg__SVGID_00000085218296141554948930000003584226611213374366_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 8V6c0-.5-.2-1-.6-1.4-.4-.4-.9-.6-1.4-.6H5c-.5 0-1 .2-1.4.6C3.2 5 3 5.5 3 6v12c0 .5.2 1 .6 1.4.4.4.9.6 1.4.6h7c.5 0 1-.2 1.4-.6.4-.4.6-.9.6-1.4v-2",
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12h14l-3-3m0 6 3-3",
    style: {
      fill: "none",
      strokeWidth: 1.8,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })));
};
export default SvgLogout;